import React from "react"
import { Link } from "gatsby"
import whiteArrow from "../images/arrow-white.png"
import whiteCheck from "../images/check-white.png"

import { useIntl } from "gatsby-plugin-intl"

export default function TocElement(props) {
  const isBrowser = typeof window !== "undefined"
  const module = props.module
  const intl = useIntl()
  let colors
  const url = `../notion-${props.grainId}`
  if (props.grainId === props.currentGrain) {
    colors = {
      bg: props.colors.primary,
      text: props.colors.secondary,
      arrow: whiteArrow,
      check: whiteCheck,
    }
  } else {
    colors = {
      bg: "#FFF",
      text: "#000",
      arrow: props.colors.arrow,
      check: props.colors.check,
    }
  }
  return (
    <li
      className="tocElement"
      id={`notion${props.grainId}`}
      style={{
        backgroundColor: colors.bg,
        border: `1px solid ${props.colors.primary}`,
      }}
    >
      {" "}
      {isBrowser &&
      window.localStorage[module] &&
      JSON.parse(window.localStorage[module]).indexOf(Number(props.grainId)) >
        -1 ? (
        <span style={{ backgroundImage: `url(${colors.check})` }}></span>
      ) : (
        <span></span>
      )}
      <Link to={url} style={{ color: colors.text }}>
        {intl.formatMessage({ id: "training12" })} {props.grainId} -{" "}
        {props.name}
      </Link>
      <span style={{ backgroundImage: `url(${colors.arrow})` }}></span>
    </li>
  )
}
